import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';
import { ConfigRule } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';

export function useUpdateConfig() {
  const put = usePut(true, "tms");
  return useMutationWithErrorHandling({
    mutationFn: async ({
      organisationUnitId,
      categoryId,
      request,
    }: {
      organisationUnitId: string;
      categoryId: string;
      request: ConfigRule[];
    }) => {
      return await put(
        `${tenantHierarchyBaseUrl}/organisation-units/${organisationUnitId}/category/${categoryId}/rules`,
        request
      );
    },
  });
}
